import {
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
  useFieldLabel,
} from "ra-friendsofbabba";
import { FormTab, useTranslate } from "react-admin";
import { Input, TextContentInput } from "../../component/input";

import React from "react";
import VerificationDateField from "../fields/VerificationDateField";

const MeetVerificationTab = (props) => {
  const translate = useTranslate();
  const fieldLabel = useFieldLabel({ resource: "technical-reports" });
  return (
    <FormTab {...props} label="resources.technical_report_evals.tabs.section5">
      <Group wrapper fullWidth>
        <GroupTitle
          title={translate("resources.technical_report_evals.section5")}
        />
        <Group>
          <GroupItem lg={12} md={12} sm={12}>
            <DebouncedTextInput
              source="technical_report.verification_link"
              maxLength={1000}
              disabled
              label={fieldLabel("verification_link")}
            />
          </GroupItem>
        </Group>
        <Group>
          <GroupItem lg={6} md={6} sm={12}>
            <DebouncedTextInput
              disabled
              source="technical_report.verification_username"
              maxLength={100}
              label={fieldLabel("verification_username")}
            />
          </GroupItem>
          <GroupItem lg={6} md={6} sm={12}>
            <DebouncedTextInput
              disabled
              source="technical_report.verification_password"
              maxLength={100}
              label={fieldLabel("verification_password")}
            />
          </GroupItem>
        </Group>
        <Group>
          <GroupItem lg={12}>
            <VerificationDateField source="verification_date" />
          </GroupItem>
          <GroupItem lg={12} md={12} sm={12}>
            <Input
              source="verification_eval"
              multiline
              maxLength={2000}
              component={<TextContentInput />}
            />
          </GroupItem>
        </Group>
      </Group>
    </FormTab>
  );
};

export default MeetVerificationTab;
